import React from 'react';

import type { NFTTokenType, TokenType } from 'types/api/token';

import type { PopoverContentProps } from 'toolkit/chakra/popover';
import {
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  PopoverRoot,
} from 'toolkit/chakra/popover';
import FilterButton from 'ui/shared/filters/FilterButton';

interface Props<T extends TokenType | NFTTokenType> {
  children: React.ReactNode;
  contentProps?: PopoverContentProps;
  isLoading?: boolean;
  filterName?: string;
  selectedValues?: Array<T>;
  placeholder: string;
  onRemoveTypeFilter: (nextValue: T) => void;
}

const PopoverFilter = <T extends TokenType | NFTTokenType>({
  children,
  contentProps,
  isLoading,
  filterName,
  selectedValues,
  placeholder,
  onRemoveTypeFilter,
}: Props<T>) => {
  return (
    <PopoverRoot size="md">
      <PopoverTrigger className="group">
        <FilterButton
          onRemoveTypeFilter={ onRemoveTypeFilter }
          placeholder={ placeholder }
          selectedValues={ selectedValues }
          filterName={ filterName }
          isLoading={ isLoading }
        />
      </PopoverTrigger>
      <PopoverContent { ...contentProps }>
        <PopoverBody display="flex" flexDir="column">
          { children }
        </PopoverBody>
      </PopoverContent>
    </PopoverRoot>
  );
};

export default React.memo(PopoverFilter) as typeof PopoverFilter;
